import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Box } from '@mui/material';
import useContentSectionContainerStyles from './useContentSectionContainerStyles';
import { EventRegistrationLayout } from '@ui/layout/EventRegistration';
import EventRegistrationStart from '@ui/pages/EventRegistration/Registration';
import EventRegistrationForm from '@ui/pages/EventRegistration/RegistrationForm';
import EventRegistrationSuccess from '@ui/pages/EventRegistration/Success';
const ContentSection = ({ selectedLayout }) => {
    const styles = useContentSectionContainerStyles();
    const [step, setStep] = useState('start');
    const handleStartRegistration = () => {
        setStep('form');
    };
    const handleSubmitForm = () => {
        setStep('success');
    };
    return (_jsx(Box, { className: 'content-inner-container', sx: {
            ...styles.contentContainer,
            maxWidth: selectedLayout === 'desktop' ? '1269px' : selectedLayout === 'tablet' ? '744px' : '428px'
        }, children: _jsx(EventRegistrationLayout, { embeddedPreview: true, previewLayout: selectedLayout, children: step === 'start' ? (_jsx(EventRegistrationStart, { handleStartRegistration: handleStartRegistration, previewLayout: selectedLayout })) : step === 'form' ? (_jsx(EventRegistrationForm, { onSubmitForm: handleSubmitForm, mode: 'preview', previewLayout: selectedLayout })) : step === 'success' ? (_jsx(EventRegistrationSuccess, { previewLayout: selectedLayout })) : null }) }));
};
export default ContentSection;
